/** Strings of the changelog: the page anybody can read, and the two admin cards behind it. */
export const ca_changelog = {
  changelogPage: {
    title: 'Novetats',
    intro: 'Què hem anat canviant, explicat per a qui hi juga.',
    empty: 'Encara no hi ha res escrit aquí.',
    error: 'No s’han pogut carregar les novetats.',
    unreleased: 'En preparació',
    unreleasedHint: 'Ja fet i encara sense versió publicada.',
    version: (v: string) => `Versió ${v.replace(/^v/, '')}`,
    kinds: {
      NEW: 'Nou',
      BETTER: 'Millor',
      FIXED: 'Arreglat',
      GONE: 'Retirat',
    } as Record<string, string>,
    icons: {
      NEW: 'stars',
      BETTER: 'lightning-charge',
      FIXED: 'wrench-adjustable',
      GONE: 'trash3',
    } as Record<string, string>,
  },

  /**
   * Per què Discord ha dit que no, en comptes de dir que ha dit que no. Cada
   * codi és una cosa i una sola, i cadascuna s’arregla en un lloc diferent:
   * el token al portal, la invitació al servidor, els permisos al canal.
   */
  discordRefusals: {
    codes: {
      '50013':
        'El bot és al canal però no hi pot escriure. Dona-li «Enviar missatges» i «Incrustar enllaços» als permisos del canal.',
      '50001':
        'El bot no veu el canal: o no és al servidor de Discord, o el canal li està tancat. Torna a convidar-lo amb permisos.',
      '10003':
        'Aquest identificador de canal no existeix per al bot. Torna a copiar-lo amb el clic dret al canal.',
      '50035': 'Discord ha rebutjat la forma del missatge. Això és cosa de la plataforma, no teva.',
      '50007': 'El bot no pot enviar missatges a aquesta destinació.',
    } as Record<string, string>,
    unauthorised:
      'Discord no reconeix el token. Prova «Qui és el bot?» i, si cal, genera’n un de nou.',
    rateLimited: 'Discord ha demanat que esperem. Torna-ho a provar d’aquí a un moment.',
    unreachable: 'No s’ha pogut arribar a Discord. Torna-ho a provar d’aquí a una estona.',
    other: (status: number, text: string) =>
      `Discord ha contestat ${status}${text ? `: ${text}` : ''}.`,
  },

  discordBot: {
    card: 'Bot de Discord',
    intro:
      'Un sol bot per a tot el que la plataforma digui al Discord del grup. Sense token, els avisos surten pels webhooks de sempre, i sense webhooks no surt res.',
    enabled: 'Bot actiu',
    token: 'Token del bot',
    tokenHint:
      'A discord.com/developers/applications, pestanya «Bot»: «Reset Token» i copia’l aquí. Discord no el torna a mostrar mai més.',
    tokenSet: 'Hi ha un token desat; deixa-ho en blanc per mantenir-lo.',
    tokenUnset: 'Cap token desat.',
    permissions:
      'El bot ha de ser al servidor de Discord i tenir permís per escriure als canals que triïs.',
    identity: 'Qui és el bot?',
    identityOk: (name: string) => `Discord diu que aquest token és de ${name}.`,
    identityBad: 'Discord no reconeix aquest token.',
    identityUnset: 'Cap token per provar.',
    channels: 'Canals',
    channelSessions: 'Sessions',
    channelVotes: 'Votacions',
    channelChangelog: 'Novetats',
    channelProves: 'Proves',
    publicKey: 'Clau pública de l’aplicació',
    publicKeyHint:
      'A discord.com/developers/applications, pestanya «General Information», «Public Key»: 64 caràcters. Amb ella la plataforma comprova cada botó premut a Discord; buida, les proves s’anuncien sense botons.',
    channelHint:
      'L’identificador numèric del canal: a Discord, amb el mode de desenvolupador activat, clic dret al canal i «Copia l’identificador del canal».',
    transports: {
      bot: 'pel bot',
      webhook: 'per webhook',
      none: 'sense sortida',
    } as Record<string, string>,
    saved: 'Desat.',
  },

  changelogAdmin: {
    card: 'Publicació de novetats',
    intro:
      'Quan la plataforma arrenca amb una versió que el canal encara no coneix, el bot en penja el resum. El que encara no té versió no es publica mai sol.',
    enabled: 'Publica les novetats al Discord',
    mode: 'Quan ho publica',
    modes: {
      RELEASE: 'Per versió: un missatge amb tot el que canvia',
      ENTRY: 'Una línia per canvi',
      MANUAL: 'Només quan premo el botó',
    } as Record<string, string>,
    mention: 'Rol a avisar',
    mentionHint:
      'L’identificador del rol que rep la menció quan surt una versió. En blanc, no avisa ningú.',
    publish: 'Publica-ho ara',
    republish: 'Torna-ho a publicar',
    publishedAt: (when: string) => `Publicat el ${when}`,
    never: 'Sense publicar',
    seeded: 'Ja hi era quan es va configurar; no s’ha publicat.',
    unreleasedNever: 'Sense versió: no es publica.',
    entriesCount: (n: number) => (n === 1 ? '1 canvi' : `${n} canvis`),
    sent: 'Publicat al Discord.',
    reasons: {
      disabled: 'La publicació de novetats està desactivada.',
      unconfigured: 'Cap canal ni webhook de novetats configurat.',
      unknown: 'Això ja no és al fitxer de novetats.',
      unreleased: 'Encara no té versió; publica-ho quan en tingui.',
      refused: 'Discord no ho ha acceptat. Mira el token i els permisos del canal.',
    } as Record<string, string>,
  },
};
